import {GetIncomeTaxPDFParams} from 'domain/usecases';
import {makeGetIncomeTaxPDF} from 'main/factories/usecases';

export const getIncomeTaxPdf = async (params: GetIncomeTaxPDFParams) => {
	const response = await makeGetIncomeTaxPDF().get(params);
	return response;
};
